import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { IBatchOpen } from '../../../models/batches';
import { IGroupSentDetail } from '../../../models/groupSentDetail';
import { IMaterialsPerSubActivity } from '../../../models/materials';
import { IStudentPerBatches } from '../../../models/students';
import { grupoBatches } from '../../../utilities/batchUtil';
import { excelExport } from '../../../utilities/excel-export';
import { AppDispatch, RootState } from '../../store';
import { getMaterialsPerSubActivity } from '../materials';
import { setBatchOpen, setBatchTrackingNumber, setBatchesOpen, setBatchesShipped, setStudentsByOpenBatch, startLoadingBatchesOpen, stopLoadingBatchesOpen } from './batchesSlice';

export const getBatchesOpen = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());
        const resp = await fulfillmentApi.get(`batches/open`);

        const batchesOpen = resp.data;
        const batchesGrouped = grupoBatches(batchesOpen);

        dispatch(setBatchesOpen({ batchesOpen, batchesGrouped }));
    }
}

export const getBatchesShipped = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());
        const resp = await fulfillmentApi.get(`batches/shipped`);

        const batchesShipped = resp.data;

        dispatch(setBatchesShipped({ batchesShipped }));
    }
}

export const getStudentsByOpenBatch = (batchOpenId: number) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());
        const resp = await fulfillmentApi.get(`batches/students/${batchOpenId}`);

        dispatch(setStudentsByOpenBatch({ studentsBatches: resp.data }));
    }
}

export const getCurrentBatchOpen = (batchOpenId: number) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());
        const resp = await fulfillmentApi.get(`batches/batchopen/${batchOpenId}`);

        const currentBatch = resp.data;
        dispatch(setBatchOpen({ currentBatch }));
    }
}

export const downloadBatchesShippedDetails = (groupSentId: number, uniqueIdentifier: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());
        await fulfillmentApi.get(`batches/shippeddetails/${groupSentId}`)
            .then(async function (response) {
                const responseObject = response.data;

                const objectToPrint = (responseObject as IGroupSentDetail[]).map(d => ({
                    dateOfOrder: d.dateOfOrder,
                    firstName: d.firstName,
                    lastName: d.lastName,
                    shipToName: d.shipToName,
                    address: d.address,
                    city: d.city,
                    state: d.state,
                    zip: d.zip,
                    country: d.country,
                    phone: d.phone,
                    email: d.email,
                    syStudentId: d.syStudentId,
                    orderQuantity: d.orderQuantity,
                    orderCode: d.orderCode,
                    orderNumber: d.orderNumber,
                    commentsToBmi: d.commentsToBmi,
                    personPlacingOrder: d.personPlacingOrder,
                    shippingMethod: d.shippingMethod
                }));

                excelExport(objectToPrint, `${uniqueIdentifier}`);
            }).catch(function (error) {
                dispatch(stopLoadingBatchesOpen());
            });

        dispatch(stopLoadingBatchesOpen());
    }
}

export const processBatch = (studentPerBatches: IStudentPerBatches[], materialsList: IMaterialsPerSubActivity[], batchOpen: IBatchOpen) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());

        await fulfillmentApi.put(`batches/process/`, studentPerBatches)
            .then(async function (response) {
                const responseObject = response.data;
                console.log(responseObject);

                const objectToPrint = (responseObject as IGroupSentDetail[]).map(d => ({
                    dateOfOrder: d.dateOfOrder,
                    firstName: d.firstName,
                    lastName: d.lastName,
                    shipToName: d.shipToName,
                    address: d.address,
                    city: d.city,
                    state: d.state,
                    zip: d.zip,
                    country: d.country,
                    phone: d.phone,
                    email: d.email,
                    syStudentId: d.syStudentId,
                    orderQuantity: d.orderQuantity,
                    orderCode: d.orderCode,
                    orderNumber: d.orderNumber,
                    commentsToBmi: d.commentsToBmi,
                    personPlacingOrder: d.personPlacingOrder,
                    shippingMethod: d.shippingMethod
                }));

                excelExport(objectToPrint, `${batchOpen.uniqueIdentifier}`);
                dispatch(getCurrentBatchOpen(batchOpen.id));
                dispatch(getStudentsByOpenBatch(batchOpen.id));
                dispatch(getMaterialsPerSubActivity(batchOpen.id));
            }).catch(function (error) {
                //Ejemplo para manejar los errores
                // if (error.response) {
                //     // La respuesta fue hecha y el servidor respondió con un código de estado
                //     // que esta fuera del rango de 2xx
                //     console.log(error.response.data);
                //     console.log(error.response.status);
                //     console.log(error.response.headers);
                // } else if (error.request) {
                //     // La petición fue hecha pero no se recibió respuesta
                //     // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
                //     // http.ClientRequest en node.js
                //     console.log(error.request);
                // } else {
                //     // Algo paso al preparar la petición que lanzo un Error
                //     console.log('Error', error.message);
                // }
                //console.log(error.config);
                //dispatch(errorSaving({ error: error.response.data }));
                dispatch(stopLoadingBatchesOpen());
            });

        dispatch(stopLoadingBatchesOpen());
    }
}

export const getBatchTrackingNumber = (batchId: number) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingBatchesOpen());
        const resp = await fulfillmentApi.get(`batches/details/${batchId}`);

        const batchesTrackingNumber = resp.data;
        dispatch(setBatchTrackingNumber({ batchesTrackingNumber }));
    }
}
